namespace TabAurous.ECommerce {
    export namespace ECommSalesReturnItemsService {
        export const baseUrl = 'ECommerce/ECommSalesReturnItems';

        export declare function Create(request: Serenity.SaveRequest<ECommSalesReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommSalesReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommSalesReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/ECommSalesReturnItems/Create",
            Update = "ECommerce/ECommSalesReturnItems/Update",
            Delete = "ECommerce/ECommSalesReturnItems/Delete",
            Retrieve = "ECommerce/ECommSalesReturnItems/Retrieve",
            List = "ECommerce/ECommSalesReturnItems/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommSalesReturnItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
